import deMessages from '../locales/de_DE.json';

const deLang = {
  messages: {
    ...deMessages,
  },
  locale: 'de-DE',
};
export default deLang;
